// Optimize image URLs for fast delivery.
// - Our own object-storage images (/api/media/file/..) support on-the-fly resize+WebP via ?w=
// - Legacy Shopify CDN images use the _WxH suffix trick
// `size` accepts an int width (e.g. 400) or a legacy string like '400x400'.
export const getOptimizedImageUrl = (url, size = 400) => {
  if (!url) return '';
  const w = typeof size === 'string' ? (parseInt(size, 10) || 400) : size;
  if (url.startsWith('/api/media/file/')) {
    return `${url}${url.includes('?') ? '&' : '?'}w=${w}`;
  }
  if (url.includes('cdn.shopify.com')) {
    return url.replace(/(\.[a-z]+)(\?|$)/i, `_${w}x${w}$1$2`);
  }
  return url;
};
